if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        if (this.keyHandler) document.removeEventListener('keydown', this.keyHandler);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.addNavArrows();
        this.showActiveMedia();
        this.keyHandler =
          this.keyHandler ||
          ((event) => {
            if (event.code === 'ArrowRight') this.stepMedia(1);
            if (event.code === 'ArrowLeft') this.stepMedia(-1);
          });
        document.addEventListener('keydown', this.keyHandler);
      }

      mediaItems() {
        return Array.from(this.querySelectorAll('[role="document"] [data-media-id]'));
      }

      addNavArrows() {
        if (this.navBuilt) return;
        this.navBuilt = true;
        if (this.mediaItems().length < 2) return;
        const dialog = this.querySelector('[role="dialog"]');
        [
          ['prev', '←', -1],
          ['next', '→', 1],
        ].forEach(([dir, glyph, step]) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `product-media-modal__nav product-media-modal__nav--${dir}`;
          button.setAttribute('aria-label', dir === 'prev' ? 'previous image' : 'next image');
          button.textContent = glyph;
          // ModalDialog closes the media modal on pointerup anywhere — keep arrow
          // presses from reaching it (pointerup fires before click)
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.stepMedia(step);
          });
          dialog.appendChild(button);
        });
      }

      stepMedia(step) {
        const items = this.mediaItems();
        if (items.length < 2) return;
        const current = this.querySelector('[data-media-id].active') || items[0];
        const target = items[(items.indexOf(current) + step + items.length) % items.length];
        current.classList.remove('active');
        target.classList.add('active');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
